import { HTMLAttributes } from 'react';

export type GetMessageHyperlinkValueParams = Partial<HTMLAttributes<HTMLAnchorElement>> &
	Record<string, string> & {
		localizedHref: string;
	};

export function getMessageHyperlinkValue(params: GetMessageHyperlinkValueParams) {
	const { localizedHref, ...rest } = params;

	return (chunks: React.ReactNode) => {
		return (
			<a
				href={params.localizedHref}
				{...rest}
				data-event="clicked"
				data-event-component="linkButton"
				data-product-key="confluence"
			>
				{chunks}
			</a>
		);
	};
}
